// extracted by mini-css-extract-plugin
module.exports = {"phrase":"phrase--3va5P","numbered":"numbered--FuR10","name":"name--ikW4Q","text":"text--3Ztgr","dialoguename":"dialoguename--3GGrq","dialoguetext":"dialoguetext--358fr","container":"container--2Qetk","withAudio":"withAudio--UfYZG","audio":"audio--1PTBT","play":"play--LRPte"};
    if(module.hot) {
      // 1732531518777
      var cssReload = require("/home/kartik/kvr-lsf/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"esModule":false,"modules":{"namedExport":false},"locals":true});
      module.hot.dispose(cssReload);
      
    }
  